import React, { useContext, useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import { Autocomplete, Button, Stack } from '@mui/material'
import ucwords from 'ucwords'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ContextData } from './Components/ContextData';
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const EmployeeEdit = (props) => {

    const context_data = useContext(ContextData)

    var navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();

    var employeeRightsList = global.config.employee_rights_list

    const [employeeData, setEmployeeData] = useState(false);
    const [allEmployeesData, setAllEmployeesData] = useState(false);
    const [loginData, setLoginData] = useState(false);
    const [userRightStatus, setUserRightStatus] = useState(false);
    const [employeeRights, setEmployeeRights] = useState(false)
    const [empJoinDate, setEmpJoinDate] = useState(new Date())
    const [employeeType, setEmployeeType] = useState("Employee");


    useEffect(() => {
        if (localStorage.getItem("login_data")) {
            setLoginData(localStorage.getItem("login_data"))
            var login_data = JSON.parse(localStorage.getItem("login_data"))
            setLoginData(login_data)

            var isAvailable;

            if (login_data.employee_type == "MASTERUSER") {
                isAvailable = true;
            } else if (login_data.employee_rights) {
                var employee_rights_arr = (login_data.employee_rights).trim().split(",");
                var regex = new RegExp(employee_rights_arr.join("|"), "i");
                isAvailable = regex.test("ADD_EMPLOYEE") || login_data.employee_type == "MASTERUSER";
            } else {
                navigate("/noAccess")
            }
            setUserRightStatus(isAvailable)
            if (isAvailable != true) { navigate("/noAccess") }

            var employee_table_id = searchParams.get("id");

            getEmployees(employee_table_id);
            getAllEmployees()
        } else {
            navigate("/logout")
        }

        if (!localStorage.getItem("employee_id")) {
            navigate("/logout");
        }

    }, [])

    function getEmployees(employee_table_id) {
        context_data.setProcessing(true)
        const getEmployeesUrl = global.config.server_url + "getEmployees.php";
        axios.post(getEmployeesUrl, { employee_table_id: employee_table_id }).then((getEmployeesResponse) => {
            if (getEmployeesResponse.data) {
                setEmployeeData(getEmployeesResponse.data);
                context_data.setProcessing(false)
            } else {
                alert("error in getting data")
                context_data.setProcessing(false)
            }
        }).catch(err => { console.log(err); context_data.setProcessing(false) });
    }

    function getAllEmployees() {
        context_data.setProcessing(true)
        const getEmployeesUrl = global.config.server_url + "getEmployees.php";
        axios.post(getEmployeesUrl, { all_data: true }).then((getEmployeesResponse) => {
            if (getEmployeesResponse.data) {
                setAllEmployeesData(getEmployeesResponse.data);
                context_data.setProcessing(false)
            } else {
                alert("error in getting data")
                context_data.setProcessing(false)
            }
        }).catch(err => { console.log(err); context_data.setProcessing(false) });
    }

    const [errorEmployeeId, setErrorEmployeeId] = useState(false);
    const [errorEmployeeMobile, setErrorEmployeeMobile] = useState(false);
    const [errorEmployeeEmail, setErrorEmployeeEmail] = useState(false);

    const checkEmployeeId = (e) => {
        var employee_id = e.target.value.toUpperCase()
        for (var i = 0; i < allEmployeesData.length; i++) {
            if (allEmployeesData[i].employee_id == employee_id) {
                setErrorEmployeeId(true)
                break;
            } else {
                setErrorEmployeeId(false)
            }
        }
    }

    const checkEmployeeMobile = (e) => {
        var employee_mobile = e.target.value.toUpperCase()
        for (var i = 0; i < allEmployeesData.length; i++) {
            if (employeeData.employee_id != allEmployeesData[i].employee_id && allEmployeesData[i].employee_mobile == employee_mobile && allEmployeesData[i].employee_status == "ACTIVE") {
                setErrorEmployeeMobile(true)
                break;
            } else {
                setErrorEmployeeMobile(false)
            }
        }
    }

    const checkEmployeeEmail = (e) => {
        var employee_email = e.target.value.toUpperCase()
        for (var i = 0; i < allEmployeesData.length; i++) {
            if (allEmployeesData[i].employee_email) {
                if (employeeData.employee_id != allEmployeesData[i].employee_id && (allEmployeesData[i].employee_email.toUpperCase()) == employee_email && allEmployeesData[i].employee_status == "ACTIVE") {
                    setErrorEmployeeEmail(true)
                    break;
                } else {
                    setErrorEmployeeEmail(false)
                }
            } else {
                setErrorEmployeeEmail(false)
            }
        }
    }

    const submitEditEmployee = (e) => {
        e.preventDefault();

        if (errorEmployeeId || errorEmployeeMobile || errorEmployeeEmail) { alert("Clear the errors"); return; }
        else {
            context_data.setProcessing(true);
            var employee_rights_arr = [];
            for (let i = 0; i < employeeRights.length; i++) {
                const element = employeeRights[i];
                employee_rights_arr.push(element.empRight)
            }

            var employee_rights = employee_rights_arr.toString();

            var employee_id = (e.target.employee_id.value).toUpperCase();
            var employee_name = (e.target.employee_name.value).toUpperCase();
            var employee_mobile = (e.target.employee_mobile.value).toUpperCase();
            var employee_email = (e.target.employee_email.value).toUpperCase();
            var employee_gender = (e.target.employee_gender.value).toUpperCase();
            var employee_joindate = (e.target.employee_joindate.value).toUpperCase();
            var employee_type = (e.target.employee_type.value).toUpperCase();
            var employee_designation = e.target.employee_designation ? (e.target.employee_designation.value).toUpperCase() : "";
            var employee_status = (e.target.employee_status.value).toUpperCase();

            var submitEditEmployeeData = {
                id: employeeData.id,
                employee_rights: employee_rights,
                employee_id: employee_id,
                employee_name: employee_name,
                employee_mobile: employee_mobile,
                employee_email: employee_email,
                employee_gender: employee_gender,
                employee_joindate: employee_joindate,
                employee_type: employee_type,
                employee_designation: employee_designation,
                employee_status: employee_status,

                login_employee_id: (localStorage.getItem("employee_id")),
                login_employee_name: (localStorage.getItem("employee_name")),

            }

            var submitEditEmployeeUrl = global.config.server_url + "updateEmployee.php";
            axios.post(submitEditEmployeeUrl, submitEditEmployeeData).then((response) => {
                if (response.data === true) {
                    alert("Employee Edited");
                    context_data.setProcessing(false);
                    navigate({ pathname: "/allEmployees", state: { login_data: loginData } });
                } else {
                    alert("Error in Editing Employee");
                    context_data.setProcessing(false);
                }
            }).catch(err => { console.log(err); alert("Error in Editing Employee"); context_data.setProcessing(false); });
        }
    }

    const getEmployeeRights = () => {
        if (employeeData.employee_rights) {
            var employee_rights = employeeData.employee_rights;
            var employee_rights_arr = employee_rights.split(",")
            var result_arr = employeeRightsList.filter(right => employee_rights_arr.includes(right.empRight))
            return result_arr
        } else {
            return []
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={() => navigate("/home")}>Home</Breadcrumb.Item>
                            <Breadcrumb.Item onClick={() => navigate("/allEmployees")}>Employees</Breadcrumb.Item>
                            <Breadcrumb.Item active>Edit Employee</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h3 className='text-center'>Edit Employee</h3>
                    </div>
                </div>
                {employeeData && (
                    <form onSubmit={submitEditEmployee}>
                        <div className="row ">
                            <div className="col-md-12">
                                <fieldset className='fieldset_info'>
                                    <legend className='fieldset_info_legend'>Employee Information</legend>
                                    <div className="row">

                                        <div className="col-md-4 my-2">
                                            <TextField fullWidth label="Emp ID" name="employee_id" required onChange={checkEmployeeId} error={errorEmployeeId} InputLabelProps={{ shrink: true }} defaultValue={employeeData.employee_id ? (employeeData.employee_id.toUpperCase()) : ""} />
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <TextField fullWidth label="Name" name="employee_name" required InputLabelProps={{ shrink: true }} defaultValue={employeeData.employee_name ? ucwords(employeeData.employee_name.toLowerCase()) : ""} />
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <TextField fullWidth inputProps={{ inputMode: 'numeric', pattern: '[6-9]{1}[0-9]{9}' }} label="Mobile" name="employee_mobile" required onChange={checkEmployeeMobile} error={errorEmployeeMobile} InputLabelProps={{ shrink: true }} defaultValue={employeeData.employee_mobile ? employeeData.employee_mobile : ""} />
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <TextField fullWidth label="Email" name="employee_email" required onChange={checkEmployeeEmail} error={errorEmployeeEmail} InputLabelProps={{ shrink: true }} defaultValue={employeeData.employee_email ? (employeeData.employee_email.toLowerCase()) : ""} />
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={["Male", "Female", "Other"]}
                                                defaultValue={employeeData.employee_gender ? ucwords(employeeData.employee_gender.toLowerCase()) : ""}
                                                renderInput={(params) => <TextField {...params} label="Gender" name="employee_gender" required />}
                                            />
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <Stack>
                                                    <MobileDatePicker
                                                        label="Join Date"
                                                        inputFormat="dd-MMM-yyyy"
                                                        onChange={(e) => setEmpJoinDate(e)}
                                                        renderInput={(params) => <TextField {...params} name="employee_joindate" />}
                                                    />
                                                </Stack>
                                            </LocalizationProvider>
                                        </div>
                                        <div className="col-md-4 my-2">
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={["Employee", "Masteruser"]}
                                                defaultValue={employeeData.employee_type ? ucwords(employeeData.employee_type.toLowerCase()) : ""}
                                                onChange={(e, newValue) => setEmployeeType(newValue)}
                                                renderInput={(params) => <TextField {...params} label="Type" name="employee_type" required />}
                                            />
                                        </div>
                                        {(employeeType == "Employee" &&
                                            <div className="col-md-4 my-2">
                                                <Autocomplete
                                                    disablePortal
                                                    id="combo-box-demo"
                                                    options={["Sales Manager", "Team Leader", "Sales Executive", "Pre Sales Executive"]}
                                                    defaultValue={employeeData.employee_designation ? ucwords(employeeData.employee_designation.toLowerCase()) : ""}
                                                    renderInput={(params) => <TextField {...params} label="Designation" name="employee_designation" required />}
                                                />
                                            </div>
                                        )}
                                        <div className="col-md-4 my-2">
                                            <Autocomplete
                                                disablePortal
                                                id="combo-box-demo"
                                                options={["Active", "Inactive"]}
                                                defaultValue={employeeData.employee_status ? ucwords(employeeData.employee_status.toLowerCase()) : ""}
                                                renderInput={(params) => <TextField {...params} label="Status" name="employee_status" required />}
                                            />
                                        </div>
                                        <div className="col-md-8 my-2">
                                            <Autocomplete
                                                multiple
                                                id="tags-outlined"
                                                options={employeeRightsList}
                                                getOptionLabel={(option) => option.title}
                                                onChange={(event, newValue) => {
                                                    setEmployeeRights(newValue);
                                                }}
                                                defaultValue={getEmployeeRights}
                                                filterSelectedOptions
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Emp Rights"
                                                        placeholder="Emp Rights"
                                                    />
                                                )}
                                            />

                                        </div>
                                        <div className="col-md-4 my-2">
                                            <Button type="submit" variant="contained" color="success">Submit</Button>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                )}
            </div>

        </>
    )
}

export default EmployeeEdit